// @flow
import { connect } from 'react-redux';

import Intro from './Intro';

const mapState = (state: ClientStore) => ({});
const mapDispatch = {};

export default connect(mapState, mapDispatch)(Intro);
